import * as React from "react";
import Box from "@mui/material/Box";
// import Button from '@mui/material/Button';
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import {
  TextField,
  Grid,
  Button,
  Divider,
  CircularProgress,
} from "@mui/material";
import { v4 as uuidv4 } from "uuid";
import axios from "../Axios/axiosConfig";
import Captcha from "./Captcha";
import { useSelector } from "react-redux";
import AdsterraAd from "./advertisement/AdsterraAd";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 350, sm: 450, md: 750 }, // Responsive width to accommodate the ad
  maxWidth: "95vw", // Ensure it doesn't overflow on small screens
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  maxHeight: "90vh",
  overflow: "auto",
};
// material-ui
// import { useTheme } from '@mui/material/styles';

export default function BasicModal({
  isOpen,
  handlePostText,
  editorState,
  toggleSnackBar,
  setSnackbarType,
  files,
  setUploadProgress,
  setPublishedCode,
}) {
  const customization = useSelector((state) => state.customization);
  // const theme = useTheme();
  const [isCaptchaValid, setIsCaptchaValid] = React.useState(false);
  const [error, setError] = React.useState("");
  const [codeText, setCodeText] = React.useState("");
  const [typeCodeText, setTypeCodeText] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  // const handleOpen = () => setOpen(isOpen || true);

  const handleSubmitPost = () => {
    // Set a loading state to display a loading spinner
    setLoading(true);

    //new editor code
    const rawContentData = editorState;
    //let validateEditorText = rawContentData.blocks && rawContentData.blocks.length > 0 ? rawContentData.blocks[0].text : '';
    let isValidated = validation();

    if (isValidated) {
      const content = JSON.stringify(rawContentData);

      // Create a FormData object to send the data
      const formData = new FormData();
      formData.append("content", content);
      formData.append("uniqueId", codeText);

      // Append files to FormData if they exist
      if (files.length > 0) {
        files.forEach((file) => {
          formData.append("files", file);
        });
      }

      axios
        .post("/texts/add", formData, {
          headers: {
            "Content-Type": "multipart/form-data", // Set the content type to FormData
          },
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setUploadProgress(percentCompleted);
          },
        })
        .then((response) => {
          // Set the published code so it can be displayed
          if (setPublishedCode) {
            setPublishedCode(codeText);
          }
          
          handleClose();
          setSnackbarType("postSuccess");
          toggleSnackBar();

          // Hide loading spinner after a successful response
          setLoading(false);
        })
        .catch((error) => {
          if (error.response?.status === 409) {
            setError("Given Code already exists in the system. Try a new code");
          } else {
            handleClose();
            setSnackbarType("failed");
            toggleSnackBar();
            console.error(error);
          }

          // Hide loading spinner after an error
          setLoading(false);
        })
        .finally(() => {
          setUploadProgress(0); // Hide loading spinner
        });
    }
  };
  const validation = () => {
    if (!codeText || codeText.length < 3) {
      setError("Code must be at least 3 characters long.");
      return false;
    }

    // For guest users, captcha must be valid
    if (customization.user.name === "" && !isCaptchaValid) {
      setError("Please complete the CAPTCHA.");
      return false;
    }

    // Add any other validations here if needed

    return true;
  };

  const handleTypeCode = (event) => {
    if (event.target.value?.length > 3) {
      setError("");
    }
    setTypeCodeText(event.target.value);
    setCodeText(event.target.value);
  };
  const handleClose = () => {
    setTypeCodeText("");
    setCodeText("");
    setError("");
    handlePostText();
  };

  const generateCode = () => {
    setTypeCodeText("");
    const alphanumericCode = uuidv4().split("-").join("").substring(0, 6);
    setCodeText(alphanumericCode);
  };

  const handleEnterKey = (event) => {
    if (event.key === "Enter") {
      // Trigger button click when Enter key is pressed
      handleSubmitPost();
    }
  };

  return (
    <div>
      <Modal open={isOpen} onClose={handleClose}>
        {loading ? ( // Conditionally render loading spinner or form content
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
            }}
          >
            <CircularProgress color="secondary" size={64} />{" "}
            {/* Display a loading spinner */}
          </div>
        ) : (
          <Box sx={style} onKeyDown={handleEnterKey}>
            <Typography variant="h3">Publish Text</Typography>
            <Grid
              container
              spacing={2}
              justifyContent="center"
              alignItems="center"
            >
              <Grid item xs={12} sm={5}>
                <TextField
                  fullWidth
                  label="Type Code"
                  margin="normal"
                  name="typecode"
                  type="text"
                  value={typeCodeText}
                  size="small"
                  color="secondary"
                  onChange={handleTypeCode}
                  autoComplete="off"
                />
              </Grid>
              <Grid item xs={2} sm={2}>
                <Typography variant="h6">OR</Typography>
              </Grid>
              <Grid item xs={12} sm={5}>
                <Button
                  disableElevation
                  fullWidth
                  size="small"
                  variant="contained"
                  color="secondary"
                  onClick={generateCode}
                >
                  Generate Code
                </Button>
              </Grid>
              <Grid item xs={12} sm={12}>
                <Divider sx={{ flexGrow: 1 }} orientation="horizontal" />
                <TextField
                  fullWidth
                  label="See your generated code"
                  disabled
                  margin="normal"
                  name="code"
                  value={codeText}
                  type="text"
                  size="small"
                  error={error !== ""}
                  helperText={error}
                />
              </Grid>
              {customization && customization.user.name === "" && (
                <Captcha setIsCaptchaValid={setIsCaptchaValid} />
              )}
              <Grid item xs={12} sm={6}>
                <Button
                  disableElevation
                  fullWidth
                  size="small"
                  type="submit"
                  variant="contained"
                  color="secondary"
                  onClick={handleSubmitPost}
                  disabled={customization.user.name === "" && !isCaptchaValid}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
            
            {/* Adsterra Advertisement Banner */}
            <Box 
              sx={{ 
                mt: 3, 
                pt: 2,
                borderTop: '1px solid #e0e0e0',
              }}
            >
              <AdsterraAd adKey="be7dedbe5d1d341393c334ba9657d8a2" />
            </Box>
          </Box>
        )}
      </Modal>
    </div>
  );
}
